var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',[_c('items-table',{ref:"itemsTable",attrs:{"id":"list-item","resourceName":"itemResourcesList","url":_vm.endpoints.findAll,"fields":_vm.fields}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }